import React, { useEffect, useState } from "react";
import { Button, Typography } from "@mui/material";

const InstallPWA = () => {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      console.log("we are being triggered :D");
      e.preventDefault();
      setPromptInstall(e);
      setSupportsPWA(true);
    };
    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("transitionend", handler);
  }, []);

  const onClick = (evt) => {
    evt.preventDefault();
    if (!promptInstall) {
      return;
    }
    promptInstall.prompt();
  };
  if (!supportsPWA) {
    return null;
  }
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        paddingBottom: 60,
      }}
    >
      <Typography variant="subtitle1" align="center">
        You may use this app in a web browser or use the “Install” option to
        copy the app to your phone, tablet or computer.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        fullWidth
        className="form-input"
        size="large"
        onClick={onClick}
      >
        Install
      </Button>
    </div>
  );
};

export default InstallPWA;
